import { render, staticRenderFns } from "./navigationLift.vue?vue&type=template&id=40a996c2&scoped=true&"
import script from "./navigationLift.vue?vue&type=script&lang=js&"
export * from "./navigationLift.vue?vue&type=script&lang=js&"
import style0 from "./navigationLift.vue?vue&type=style&index=0&id=40a996c2&prod&scoped=true&lang=css&"
import style1 from "./navigationLift.vue?vue&type=style&index=1&id=40a996c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a996c2",
  null
  
)

export default component.exports